export default "/_next/static/images/ab351dcfc8743e20184160849839b0b9.svg";